import { createPortal } from "react-dom";

import { CloseIconSlimButton } from "@/design-system/icons/close-icon-slim";
import type { IMap } from "@Components/Map";
import { Map } from "@Components/Map";
import * as stylex from "@stylexjs/stylex";

import * as css from "./MapMobile.module.css";

export interface IMapMobile {
    title: string;
    map: IMap;
    onClose?: () => void;
}

export const MapMobile = (props: IMapMobile) =>
    createPortal(
        <div className={css.mapMobileComponent}>
            <div className={css.title}>
                <span>{props.title}</span>
                <div className={css.closeLink}>
                    <CloseIconSlimButton styleX={styles.close} onClick={props.onClose} />
                </div>
            </div>
            <Map {...props.map} />
        </div>,
        document.body,
    );

const styles = stylex.create({
    close: {
        display: "block",
        height: "14px",
        width: "14px",
    },
});
